<template>
  <div v-if="datacollection" class="vacancy-stat">
    <GoogleStatChart
      :chart-data="datacollection"
      :height="175"
    ></GoogleStatChart>
  </div>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import GoogleStatChart from "./GoogleStatChart";

export default {
  components: {
    GoogleStatChart
  },
  props: {
    id: { type: [Number, String], required: true }
  },
  data() {
    return {
      datacollection: null
    };
  },
  apollo: {
    googleAd: {
      query: gql`
        query GoogleAd($id: ID!, $datapointStart: Time!) {
          googleAd(id: $id) {
            id
            datapoints(from: $datapointStart) {
              date
              clicks
              costMicros
              avgCpc
            }
          }
        }
      `,
      variables() {
        return {
          id: this.id,
          datapointStart: moment().subtract(100, "days")
        };
      }
    }
  },
  watch: {
    googleAd(stats) {
      if (!stats.datapoints) {
        this.datacollection = null;
        return;
      }

      stats.datapoints.sort((a, b) =>
        a.date > b.date ? 1 : a.date < b.date ? -1 : 0
      );

      let labels = [];
      for (let data of stats.datapoints) {
        let date = moment(data.date);
        if (labels.findIndex(val => val.diff(date) === 0) === -1) {
          labels.push(date);
        }
      }

      let clicksData = [];
      let spendData = [];
      let cpCData = [];
      for (let label of labels) {
        let clicks = 0;
        let spend = 0;
        let cpC = 0;
        for (let data of stats.datapoints) {
          let time = moment(data.date);
          if (time.diff(label) === 0) {
            clicks = data.clicks;
            spend = data.costMicros / 1000000;
            cpC = data.avgCpc / 1000000;
          }
        }

        clicksData.push(clicks);
        spendData.push(spend);
        cpCData.push(cpC);
      }

      this.datacollection = {
        labels,
        datasets: [
          {
            label: "Klicks",
            borderColor: "#13358e",
            data: clicksData,
            fill: true,
            backgroundColor: "#13358e",
            pointHoverBackgroundColor: "#000000"
          },
          {
            label: "Ausgegeben",
            borderColor: "#55c400",
            data: spendData,
            fill: true,
            backgroundColor: "#55c400",
            pointHoverBackgroundColor: "#000000"
          },
          {
            label: "CPC",
            borderColor: "#d1232b",
            data: cpCData,
            fill: true,
            backgroundColor: "#d1232b",
            pointHoverBackgroundColor: "#000000"
          }
        ]
      };
    }
  }
};
</script>
